import React from 'react';
import { Button, Typography } from '@ann/web-components';
import { ErrorContainer } from './ChatErrorBoundary.styled';

/**
 * Error boundary que captura errores de render en el chat.
 * Si ConversationView, AgentView o cualquier componente de streaming falla,
 * muestra un fallback amigable en vez de crashear toda la app.
 * El boton Reintentar resetea el boundary para volver a montar los hijos.
 */
class ChatErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      errorKey: 0,
    };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('[ChatErrorBoundary] Chat failed:', error, errorInfo);
  }

  handleRetry = () => {
    this.setState((prev) => ({ hasError: false, errorKey: prev.errorKey + 1 }));
  };

  render() {
    const { hasError, errorKey } = this.state;
    const { children } = this.props;

    if (hasError) {
      return (
        <ErrorContainer>
          <Typography category="title" size="medium" weight="bold" color="title">
            Something went wrong
          </Typography>
          <Typography category="body" size="medium" weight="regular" color="body">
            The chat encountered an unexpected error. Your conversation is safe.
          </Typography>
          <Button label="Retry" size="medium" type="gradient" onClick={this.handleRetry} />
        </ErrorContainer>
      );
    }

    return <React.Fragment key={errorKey}>{children}</React.Fragment>;
  }
}

export default ChatErrorBoundary;
